// menuContext.js
import { createContext, useContext, useMemo, useState } from "react";

const MenuContext = createContext();

export default function MenuProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const value = useMemo(
    () => ({
      isOpen,
      toggleMenu: () => setIsOpen((prev) => !prev),
      closeMenu: () => setIsOpen(false),
      openMenu: () => setIsOpen(true),
    }),
    [isOpen]
  );

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
}

export const useMenu = () => useContext(MenuContext);
